export default {
    "digitalisieren": () => import('@/views/content/custom/Digitalisieren'),
    "einrahmen": () => import('@/views/content/custom/Einrahmen'),
    "bearbeitungColorierung": () => import('@/views/content/custom/BearbeitungColorierung'),
    "industriefotografie": () => import('@/views/content/custom/Industriefotografie'),
    "passbilder": () => import('@/views/content/custom/Passbilder'),
    "fotobuecher": () => import('@/views/content/custom/Fotobuecher'),
    "mehr": () => import('@/views/content/custom/Mehr')
}